// Vendor imports
const Cookies = require('js-cookie')
// Container imports
const { showTooltip } = require('../actions')
const TooltipsDismissedCache = require('../utils/dismissed-cache')

const dismissedCache = TooltipsDismissedCache.forLocalStorageKey('ftu_tooltips')

function isUserEligible() {
  return !!Cookies.get('ftu_tooltips')
}

// Tooltip action dispatchers

function showCollectionProfileSubscribeTooltip() {
  const key = 'collection-profile-subscribe'
  return function (dispatch, getState) {
    if (!isUserEligible() || dismissedCache.get(key)) {
      return false
    }
    const { user, collection, router } = getState()
    // Only show the tooltip on collection-profile posts page
    if (router.action !== 'collection-profile.showPosts') {
      return false
    }
    // Don't show the tooltip for yourself or if you're already subscribed
    if (user.id === collection['user_id'] || collection.isFollowing) {
      return false
    }
    dispatch(showTooltip({
      key,
      title: 'Subscribe',
      body: 'You’ll see new posts from this collection in your recommendations.',
      onDismiss() { dismissedCache.set(key) }
    }))
    return true
  }
}

function showUserProfileFollowTooltip() {
  const key = 'user-profile-follow'
  return function (dispatch, getState) {
    if (!isUserEligible() || dismissedCache.get(key)) {
      return false
    }
    const { user, profileUser, router } = getState()
    // Only show the tooltip on user-profile pages
    if (!router.action.startsWith('user-profile.')) {
      return false
    }
    // Don't show the tooltip for yourself or if you're already following the user
    if (user.id === profileUser.id || profileUser.isFollowing) {
      return false
    }
    dispatch(showTooltip({
      key,
      title: 'Follow',
      body: 'You’ll see more of this person’s posts & collections if you follow them.',
      onDismiss() { dismissedCache.set(key) }
    }))
    return true
  }
}

module.exports = {
  showCollectionProfileSubscribeTooltip,
  showUserProfileFollowTooltip
}
